// Video Product Showcase JavaScript
(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initVideoShowcase();
  });

  function initVideoShowcase() {
    // Select all video showcases on the page
    const videoShowcases = document.querySelectorAll('.vps-video-showcase');
    
    if (videoShowcases.length === 0) {
      console.warn('No video showcases found');
      return;
    }

    // Initialize each video showcase independently
    videoShowcases.forEach(function(showcase) {
      const video = showcase.querySelector('#vps-promo-video');
      const playPauseBtn = showcase.querySelector('#vps-play-pause-btn');
      const playIcon = showcase.querySelector('.vps-play-icon');
      const pauseIcon = showcase.querySelector('.vps-pause-icon');

      // Check if elements exist
      if (!video || !playPauseBtn || !playIcon || !pauseIcon) {
        console.warn('Video showcase elements not found in showcase:', showcase);
        return;
      }

      // Initial state - video is paused, show play button
      video.pause();
      showPlayIcon();

      // Play/Pause button click handler
      playPauseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(video.hideButtonTimeout);
        togglePlayPause();
      });

      // Video click handler (optional - allows clicking video to play/pause)
      video.addEventListener('click', function(e) {
        e.stopPropagation();
        togglePlayPause();
      });

      // Listen for video events to update button state
      video.addEventListener('play', function() {
        hideButton();
      });

      video.addEventListener('pause', function() {
        showPlayIcon();
      });

      // Handle video end
      video.addEventListener('ended', function() {
        showPlayIcon();
        video.currentTime = 0; // Reset to beginning
      });

      // Show button on mouse move over video or button
      const videoWrapper = video.closest('.vps-video-wrapper');
      const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      function showControlsOnHover() {
        if (!video.paused) {
          playPauseBtn.style.display = 'flex';
          showPauseIcon();
          
          // Hide button again after 2 seconds of no mouse movement (only on desktop)
          if (!isMobile) {
            clearTimeout(video.hideButtonTimeout);
            video.hideButtonTimeout = setTimeout(function() {
              if (!video.paused) {
                hideButton();
              }
            }, 2000);
          }
        }
      }

      // Desktop hover behavior
      if (!isMobile) {
        videoWrapper.addEventListener('mousemove', showControlsOnHover);
        playPauseBtn.addEventListener('mouseenter', showControlsOnHover);

        videoWrapper.addEventListener('mouseleave', function() {
          if (!video.paused) {
            clearTimeout(video.hideButtonTimeout);
            video.hideButtonTimeout = setTimeout(function() {
              if (!video.paused) {
                hideButton();
              }
            }, 500);
          }
        });
      } else {
        // Mobile touch behavior - show button on tap
        videoWrapper.addEventListener('touchstart', function(e) {
          if (!video.paused) {
            if (playPauseBtn.style.display === 'none') {
              playPauseBtn.style.display = 'flex';
              showPauseIcon();
              
              // Hide after 3 seconds on mobile
              clearTimeout(video.hideButtonTimeout);
              video.hideButtonTimeout = setTimeout(function() {
                if (!video.paused) {
                  hideButton();
                }
              }, 3000);
              
              e.preventDefault();
            }
          }
        });
      }

      // Keyboard accessibility
      playPauseBtn.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          togglePlayPause();
        }
      });

      // Handle video errors
      handleVideoError(video);

      // Functions (scoped to this showcase)
      function togglePlayPause() {
        if (video.paused) {
          video.play().catch(function(error) {
            console.error('Error playing video:', error);
          });
        } else {
          video.pause();
        }
      }

      function showPlayIcon() {
        playIcon.classList.remove('vps-hidden');
        pauseIcon.classList.add('vps-hidden');
        playPauseBtn.style.display = 'flex';
        playPauseBtn.setAttribute('aria-label', 'Play video');
      }

      function showPauseIcon() {
        playIcon.classList.add('vps-hidden');
        pauseIcon.classList.remove('vps-hidden');
        playPauseBtn.style.display = 'flex';
        playPauseBtn.setAttribute('aria-label', 'Pause video');
      }

      function hideButton() {
        playPauseBtn.style.display = 'none';
      }

      // Handle visibility change (pause video when tab is not visible)
      document.addEventListener('visibilitychange', function() {
        if (document.hidden && !video.paused) {
          video.pause();
        }
      });

      // Intersection Observer for autoplay when in view (optional)
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              // Video is in view - you could auto-play here if desired
              // video.play().catch(function(error) {
              //   console.error('Autoplay failed:', error);
              // });
            } else {
              // Video is out of view - pause it
              if (!video.paused) {
                video.pause();
              }
            }
          });
        }, {
          threshold: 0.5 // Trigger when 50% of video is visible
        });

        observer.observe(video);
      }
    });
  }

  // Utility function to handle video errors
  function handleVideoError(video) {
    video.addEventListener('error', function(e) {
      console.error('Video error:', e);
      const errorMessage = document.createElement('div');
      errorMessage.className = 'vps-video-error';
      errorMessage.innerHTML = '<p>Video could not be loaded. Please try again later.</p>';
      errorMessage.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 20px;
        border-radius: 8px;
        text-align: center;
        font-family: 'Poppins', Arial, sans-serif;
        font-size: 14px;
        z-index: 10;
      `;
      
      const videoWrapper = video.parentElement;
      videoWrapper.style.position = 'relative';
      videoWrapper.appendChild(errorMessage);
    });
  }

})();